// Copyright (c) 2023 Visual Intelligence LP. All rights reserved.
//

// Struct to store dependency data from portal-api
export interface AssetVisitInfoDTO {
  id: number;                       // db key.
  jobRequestId: number;             // back pointer to JobReq
  name: string;                     // Actual site name
  lat: number | undefined;
  lon: number | undefined;
  region: string;
  height: number | undefined;
  type: number | undefined;         // construction type (id for monopole, lattice, ...)
  siteTypeId: number | undefined;   // site type Id.
  siteTypeName: string;             // site type name (GBT, RTT, ...)
}

// Class to handle dependency data from portal-api
export default class AssetVisitInfo {
  id: number;                       // db key.
  jobRequestId: number;             // back pointer to JobReq
  name: string;                     // Actual site name
  lat: number | undefined;
  lon: number | undefined;
  region: string;
  height: number | undefined;
  type: number | undefined;         // construction type
  siteTypeId: number | undefined;   // site type
  siteTypeName: string;             // site type name (GBT, RTT, ...)

  constructor(dto: AssetVisitInfoDTO) {
    this.update(dto);
  }

  get asJson(): AssetVisitInfoDTO {
    return {
      id: this.id,
      name: this.name,
      lat: this.lat,
      lon: this.lon,
      region: this.region,
      height: this.height,
      type: this.type,
      siteTypeId: this.siteTypeId,
      siteTypeName: this.siteTypeName,
      jobRequestId: this.jobRequestId 
    };
  }

  update(newData: Partial<AssetVisitInfoDTO>): AssetVisitInfoDTO {
    const updatedData = { ...this.asJson, ...newData };

    Object.assign(this, updatedData);

    return this.asJson;
  }
}

// Struct to store col vals for a row in the siteVisit grid.
export interface SiteVisitInfo {
  name: string;                     // site name
  visitName: string | undefined;    // actual site name
  lat: number | undefined;
  lon: number | undefined;
  region: string | undefined;
  height: number | undefined;
  typeName: string | undefined;     // construction type (monopole, lattice, ...)
  siteTypeName: string | undefined; // site type name (GBT, RTT, ...)
}
